(function () {
  var script = document.createElement('script');
  script.src = 'https://cdn.jsdelivr.net/npm/mathjax@3/es5/tex-svg.js';
  script.async = true;
  window.MathJax = {
    loader: {
      load: ['[tex]/color']
    },
    tex: {
      inlineMath: [['$', '$'], ['\\(', '\\)']],
      packages: { '[+]': ['color'] }
    },
  };
  document.head.appendChild(script);
})();
